(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[138],{

/***/ 3860:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xml",
      function () {
        return __webpack_require__(6332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1319);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Textarea = function(param) {
    var title = param.title, value = param.value, placeholder = param.placeholder, isWrappedStyle = param.isWrappedStyle, isError = param.isError, autoHeight = param.autoHeight, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), txt = ref[0], setTxt = ref[1];
    var parentId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var textareaId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var handleOnClick = function() {
        if (textareaId.current) textareaId.current.focus();
    };
    var handleOnChange = function(e) {
        if (textareaId.current && autoHeight) {
            textareaId.current.style.height = "auto";
            textareaId.current.style.height = textareaId.current.scrollHeight + "px";
        }
        if (onChange) onChange(e.target.value);
        setTxt(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txt),
            isWrappedStyle && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().full),
            isError && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error)
        ].filter(Boolean).join(" "),
        onClick: handleOnClick,
        ref: parentId,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtContent),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    onInput: handleOnChange,
                    ref: textareaId,
                    placeholder: placeholder,
                    children: txt
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 6332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_xml; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/Header.js + 4 modules
var Header = __webpack_require__(798);
// EXTERNAL MODULE: ./styles/modules/about/About.module.scss
var About_module = __webpack_require__(9616);
var About_module_default = /*#__PURE__*/__webpack_require__.n(About_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./components/Input.js
var Input = __webpack_require__(1121);
// EXTERNAL MODULE: ./components/Textarea.js
var Textarea = __webpack_require__(3639);
// EXTERNAL MODULE: ./styles/modules/SplitterFeed.module.scss
var SplitterFeed_module = __webpack_require__(7287);
var SplitterFeed_module_default = /*#__PURE__*/__webpack_require__.n(SplitterFeed_module);
;// CONCATENATED MODULE: ./components/SplitterFeed.js









var shakeEl = function(el) {
    el.animate([
        {
            transform: "translate3d(-2px, 0, 0)"
        },
        {
            transform: "translate3d(2px, 0, 0)"
        },
        {
            transform: "translate3d(-5px, 0, 0)"
        },
        {
            transform: "translate3d(5px, 0, 0)"
        },
        {
            transform: "translate3d(0, 0, 0)"
        }
    ], 200);
};
var Modal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var SplitterFeed = function(param) {
    var title = param.title, subtitle = param.subtitle;
    /** STATES */ var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,react.useState)(false), isModalFeedbackVisible = ref[0], setIsModalFeedbackVisible = ref[1];
    var ref1 = (0,react.useState)(false), isModalSuccessVisible = ref1[0], setIsModalSuccessVisible = ref1[1];
    var ref2 = (0,react.useState)(""), clientName = ref2[0], setClientName = ref2[1];
    var ref3 = (0,react.useState)(""), clientPhone = ref3[0], setClientPhone = ref3[1];
    var ref4 = (0,react.useState)(""), clientFeed = ref4[0], setClientFeed = ref4[1];
    var ref5 = (0,react.useState)(""), clientMail = ref5[0], setClientMail = ref5[1];
    var ref6 = (0,react.useState)(""), clientComment = ref6[0], setClientComment = ref6[1];
    var clientNameId = (0,react.useRef)();
    var clientPhoneId = (0,react.useRef)();
    var clientMailId = (0,react.useRef)();
    var clientFeedId = (0,react.useRef)();
    var inputParentId = (0,react.useRef)(null);
    var inputId = (0,react.useRef)();
    /** HANDLERS */ var handleFeedbackClick = function() {
        //console.log(clientFeed.slice(0,8) );
        if (clientFeed.slice(0, 8) === "https://" || clientFeed.slice(0, 7) === "http://") setIsModalFeedbackVisible(true);
        else shakeEl(inputParentId.current);
    };
    var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length < 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        clientFeedId.current.setError(clientFeed.length < 15);
        //console.log(clientFeed.length);
        if (clientName.length >= 3 && clientPhone.length === 11 && clientFeed.length >= 15) {
            setIsModalFeedbackVisible(false);
            setIsModalSuccessVisible(true);
            axios_default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                clientMail: clientMail,
                clientFeed: clientFeed,
                clientComment: clientComment,
                pathName: window.location.pathname,
                whatComponent: "SplitterFeed",
                location: locationState.region,
                platform: "web"
            });
            inputId.current.value = "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                title: "Обратная связь",
                visibility: isModalSuccessVisible,
                onClose: function() {
                    return setIsModalSuccessVisible(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginBottom: 18
                    },
                    children: "Спасибо за вашу заявку. В ближайшее время мы подключим фид и Ваши обьявления появятся на сайте"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                title: "Подключить фид",
                button: "Подключить",
                action: handleFormSubmit,
                visibility: isModalFeedbackVisible,
                onClose: function() {
                    return setIsModalFeedbackVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Мы принимаем XML файлы с объявлениями по недвижимости в формате Яндекс.Недвижимости доступные по ссылке"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "Название компании / агентства",
                        inputs: [
                            {
                                placeholder: "АН Солнышко",
                                value: clientName,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientNameId,
                        onChange: function(v) {
                            return setClientName(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "E-mail",
                        inputs: [
                            {
                                placeholder: "vasya@yandex.ru",
                                value: clientMail,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientMailId,
                        onChange: function(v) {
                            return setClientMail(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "Телефон",
                        inputs: [
                            {
                                placeholder: locationState.phone,
                                value: clientPhone,
                                mask: "phone",
                                type: "tel"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientPhoneId,
                        onChange: function(v) {
                            return setClientPhone(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "Ссылка на фид в формате Яндекс.Недвижимости",
                        inputs: [
                            {
                                placeholder: "https://",
                                value: clientFeed,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientFeedId,
                        onChange: function(v) {
                            return setClientFeed(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, {
                        title: "Коммментарий",
                        placeholder: "Например, \xabПодключите фид как можно быстрее\xbb",
                        autoHeight: true,
                        isWrappedStyle: true,
                        onChange: function(v) {
                            return setClientComment(v);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            textAlign: "center",
                            opacity: 0.8,
                            fontSize: 14,
                            margin: "18px 0"
                        },
                        children: [
                            "Вы соглашаетесь с",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/faq/policy",
                                target: "_blank",
                                children: "политикой конфиденциальности"
                            }),
                            " ",
                            "при отправке данной формы к нам в работу"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "block fill clear",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: [
                        "fixed",
                        (SplitterFeed_module_default()).splitter
                    ].join(" "),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SplitterFeed_module_default()).text,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (SplitterFeed_module_default()).title,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SplitterFeed_module_default()).subtitle,
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SplitterFeed_module_default()).actions,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SplitterFeed_module_default()).input,
                                    ref: inputParentId,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            className: (SplitterFeed_module_default()).inputZone,
                                            inputs: [
                                                {
                                                    placeholder: "https://",
                                                    value: clientFeed,
                                                    type: "text"
                                                }
                                            ],
                                            isWrappedStyle: true,
                                            ref: inputId,
                                            onChange: function(v) {
                                                return setClientFeed(v[0]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (SplitterFeed_module_default()).inputButton,
                                            type: "button",
                                            "aria-label": "Подключить",
                                            onClick: handleFeedbackClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                        x1: "22",
                                                        y1: "2",
                                                        x2: "11",
                                                        y2: "13"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "22 2 15 22 11 13 2 9 22 2"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SplitterFeed_module_default()).help,
                                    children: "Ссылка на фид в формате Яндекс.Недвижимости"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
SplitterFeed.defaultProps = {
    title: "Подключить xml выгрузку",
    subtitle: "Подключаем агентства недвижимости, риэлторов, застройщиков, бизнес-центры и т.п."
};
/* harmony default export */ var components_SplitterFeed = (SplitterFeed);

;// CONCATENATED MODULE: ./public/images/xml.svg
var _defs, _g, _g2, _g3, _path, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgXml = function SvgXml(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 430,
    viewBox: "0 0 701.7 431.32"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".xml_svg__cls-1{fill:#fff}.xml_svg__cls-2{fill:#e0e0e0}.xml_svg__cls-3{opacity:.3}.xml_svg__cls-4{fill:#ebebeb}.xml_svg__cls-5{fill:#f5f5f5}.xml_svg__cls-6{fill:#455a64}.xml_svg__cls-7{fill:#263238}.xml_svg__cls-8{fill:#ff725e}.xml_svg__cls-9{fill:#fafafa}.xml_svg__cls-11{fill:#ffbe9d}.xml_svg__cls-12{fill:#eb996e}"))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "xml_svg__Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-1",
    d: "M.27 49.76h152.3v101.97H.27z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M176.39 181.57v-7.24c0-4.72 0-11.64-.05-20.51 0-17.71-.07-43.18-.12-74.23l.22.22-152.28.06.27-.28v102l-.25-.25 109.72.12 31.34.07h11.23-11.12l-31.29.06-109.88.13h-.25V79.2h.29l152.28.06h.22v.21c-.05 31.11-.09 56.62-.11 74.37 0 8.84-.05 15.75-.06 20.46v5.34c0 1.22-.16 1.93-.16 1.93Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M24.1 88.69c0-.15 34.06-.27 76.08-.27s76.09.12 76.09.27-34.06.28-76.09.28-76.08-.12-76.08-.28Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M30.1 84.1a1.22 1.22 0 0 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z",
    transform: "translate(-23.82 -29.83)"
  })), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M34.29 84.1a1.22 1.22 0 1 1-1.22-1.22 1.22 1.22 0 0 1 1.22 1.22Z",
    transform: "translate(-23.82 -29.83)"
  })), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M38.41 84.1a1.22 1.22 0 1 1-1.22-1.22 1.22 1.22 0 0 1 1.22 1.22Z",
    transform: "translate(-23.82 -29.83)"
  })), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M13.37 69.49h40.62v40.63H13.37z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M155.51 110.81c0 .15-15.85.27-35.39.27s-35.39-.12-35.39-.27 15.85-.27 35.39-.27 35.39.12 35.39.27ZM155.51 118.36c0 .15-15.85.27-35.39.27s-35.39-.12-35.39-.27 15.85-.27 35.39-.27 35.39.12 35.39.27ZM155.51 125.91c0 .15-15.85.27-35.39.27s-35.39-.12-35.39-.27 15.85-.27 35.39-.27 35.39.12 35.39.27ZM126.56 133.46a9.76 9.76 0 0 1-1.64.11l-4.48.08c-3.79 0-9 .08-14.79.08s-11 0-14.79-.08l-4.48-.08a10 10 0 0 1-1.65-.11 10 10 0 0 1 1.65-.11l4.48-.08c3.78-.05 9-.08 14.79-.08s11 0 14.79.08l4.48.08a9.76 9.76 0 0 1 1.64.11Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M15.91 123.82H35v19.09H15.91zM50.53 123.82h19.09v19.09H50.53zM85.16 123.82h19.09v19.09H85.16zM119.78 123.82h19.09v19.09h-19.09z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-1",
    d: "M175.04.21h131.19V53.5H175.04z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M330.06 83.33V68.96c0-9.2-.05-22.5-.08-39l.15.15-131.19.06.2-.21v53.29l-.19-.2 94.06.09 27.28.06h7.31-7.26l-27.24.05-94.19.1h-.2v-53.7h.21l131.19.07h.14V30c0 16.51-.06 29.84-.08 39.06v13.31c0 .63-.11.96-.11.96Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M199 37.23c0-.12 29.32-.21 65.48-.21s65.5.09 65.5.21-29.32.21-65.5.21-65.48-.1-65.48-.21Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-4",
    d: "M204.49 34a.95.95 0 1 1-1-.95 1 1 0 0 1 1 .95Z",
    transform: "translate(-23.82 -29.83)"
  })), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-4",
    d: "M207.75 34a.95.95 0 1 1-.95-.95 1 1 0 0 1 .95.95Z",
    transform: "translate(-23.82 -29.83)"
  })), /*#__PURE__*/react.createElement("g", {
    className: "xml_svg__cls-3"
  }, /*#__PURE__*/react.createElement("circle", {
    className: "xml_svg__cls-4",
    cx: 186.19,
    cy: 4.18,
    r: 0.95
  })), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M186.19 16.06h31.69v31.69h-31.69z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M321 54.38c0 .12-16.31.21-36.42.21s-36.42-.09-36.42-.21 16.31-.21 36.42-.21 36.42.1 36.42.21ZM321 60.84c0 .11-16.31.2-36.42.2s-36.42-.09-36.42-.2 16.31-.21 36.42-.21 36.42.09 36.42.21ZM295 67.29a1.61 1.61 0 0 1-.48 0h-1.36l-5 .07-16.57.06-16.59.02-5-.07h-1.37a1.68 1.68 0 0 1-.48 0 2.32 2.32 0 0 1 .48 0H250l5-.06 16.58-.07 16.57.07 5 .06h1.36a2.2 2.2 0 0 1 .49-.08ZM684 101.16a4.68 4.68 0 0 1 .74-.85c.59-.58 1.31-1.31 2.16-2.16a438.4 438.4 0 0 1 7.24-7l.07-.06v.36c-2.87-2.66-5.45-5.09-7.29-6.87l-2.17-2.12a5 5 0 0 1-.75-.83 4.57 4.57 0 0 1 .88.68l2.28 2c1.9 1.71 4.52 4.1 7.39 6.76l.2.19-.2.18-.06.06c-2.85 2.72-5.45 5.16-7.35 6.9l-2.26 2.06a6.07 6.07 0 0 1-.88.7ZM661.87 81.62a5.39 5.39 0 0 1-.74.84L659 84.63c-1.83 1.81-4.39 4.29-7.24 7l-.07.06v-.37c2.87 2.67 5.45 5.1 7.29 6.88l2.17 2.12a4.53 4.53 0 0 1 .75.83 5 5 0 0 1-.88-.69l-2.28-2c-1.9-1.71-4.52-4.1-7.39-6.77l-.2-.18.2-.18.06-.07c2.85-2.71 5.45-5.15 7.35-6.9l2.24-2.04a4.66 4.66 0 0 1 .87-.7ZM667.56 105.76c-.13-.05 2.19-6.58 5.19-14.59s5.53-14.47 5.66-14.42-2.2 6.58-5.19 14.59-5.53 14.47-5.66 14.42Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M709.19 119.74V103.6c0-10.25-.06-24.9-.11-42.56l.21.21h-72l.25-.25v58.7l-.22-.22 52 .11 14.74.06h5.28-5.2l-14.7.06-52.17.11h-.22V60.64h72.47V61c0 17.71-.08 32.41-.11 42.69V118.66c0 .72-.22 1.08-.22 1.08Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M709.76 69.75c0 .14-16.27.25-36.33.25s-36.32-.11-36.32-.25 16.26-.25 36.32-.25 36.33.11 36.33.25ZM643 65.46a1 1 0 1 1-1-1 1 1 0 0 1 1 1ZM646.56 65.46a1 1 0 1 1-1-1 1 1 0 0 1 1 1ZM650.09 65.46a1 1 0 1 1-1-1 1 1 0 0 1 1 1Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-4",
    d: "M692.59 377.9c4.16-2.15 9.07-2.43 13.69-1.66 2.48.41 5.07 1.15 6.76 3s2 5.14.07 6.75a6.55 6.55 0 0 1-4.26 1.08c-3.62 0-7.64-.68-10.53 1.5-1.65 1.24-2.74 3.3-4.72 3.91a4.66 4.66 0 0 1-5.13-2.28 8 8 0 0 1-.58-5.88 9 9 0 0 1 4.7-6.42ZM683.05 359.49c2.55 3.63 7.5 2.43 9.79.21s3.26-5.44 4.15-8.5c2-7 4-14.36 2.55-21.5a12 12 0 0 0-2.75-5.85 6.23 6.23 0 0 0-5.91-2c-2.5.66-4 3.1-5.17 5.42a51.26 51.26 0 0 0-5.06 22c0 3.54.4 7.25 2.4 10.18M676.06 364.7c2.76-3.28 3.29-8.06 2.06-12.17a23.46 23.46 0 0 0-7.21-10.46 38.88 38.88 0 0 0-12.91-7.62 13.86 13.86 0 0 0-5.81-1 6.12 6.12 0 0 0-4.88 3c-1.35 2.59 0 5.74 1.36 8.3a98.45 98.45 0 0 0 8.48 12.92c2.54 3.27 5.45 6.51 9.33 8s7.9 1.31 9.95-1.38",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M682.88 414.34a8.29 8.29 0 0 0 .23-1.66c.12-1.2.26-2.71.44-4.51s.49-4.15 1-6.61a51.47 51.47 0 0 1 2.41-7.81 28.8 28.8 0 0 1 4-7.06 15 15 0 0 1 5-4.19 14.18 14.18 0 0 1 4.25-1.32 7.69 7.69 0 0 0 1.64-.24 8.6 8.6 0 0 0-1.67 0 12.77 12.77 0 0 0-4.43 1.15 14.89 14.89 0 0 0-5.31 4.22 28.24 28.24 0 0 0-4.14 7.21 47.94 47.94 0 0 0-2.38 7.93 56.11 56.11 0 0 0-.88 6.7 101 101 0 0 0-.23 4.54 7.58 7.58 0 0 0 .07 1.65Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M683.19 410.87a3.39 3.39 0 0 0 0-.77v-2.19c0-1.91 0-4.66.1-8.06.16-6.8.75-14.12 1.88-24.43 1.07-9.7 2.51-21 4-28.34.32-1.67.65-3.17 1-4.48s.54-2.46.78-3.38.38-1.57.52-2.13a3.24 3.24 0 0 0 .13-.76 4.49 4.49 0 0 0-.27.72q-.24.82-.63 2.1c-.28.92-.57 2-.9 3.36s-.71 2.81-1.07 4.47a249.06 249.06 0 0 0-4.23 26.29c-1.13 10.34-1.64 19.76-1.69 26.57 0 3.41 0 6.17.12 8.07.06.89.1 1.62.14 2.19a3.87 3.87 0 0 0 .12.77Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M683.24 392.71a17.42 17.42 0 0 0 0-2.29c-.08-1.47-.29-3.6-.7-6.2a82.83 82.83 0 0 0-2-9 74 74 0 0 0-3.78-10.7 57.22 57.22 0 0 0-11.1-17.29 27.72 27.72 0 0 0-2.61-2.42c-.4-.34-.76-.68-1.12-.95l-1-.7a14.27 14.27 0 0 0-1.93-1.23 68.67 68.67 0 0 1 6.32 5.64 59.9 59.9 0 0 1 10.82 17.22 84.12 84.12 0 0 1 3.81 10.6 89.48 89.48 0 0 1 2.05 8.91c.48 2.58.75 4.68.92 6.14a13.57 13.57 0 0 0 .32 2.27Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "m641.86 394.9 1.82 24.93h32.02l1.82-24.93h-35.66zM638.77 385.08h42.57v9.82h-42.57z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-4",
    d: "M638.77 418.87v2.73h41.87v-2.73h-41.87z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "m642.73 426.39-1.96-4.79h38.35l-2.29 4.79h-34.1z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-5",
    d: "M700.75 432.88s0 .09-.15.23l-.48.64-1.86 2.38-.08.11-.09-.11c-1.17-1.62-2.73-3.79-4.58-6.34h.27l-4.52 6.39-.14.2-.16-.19-5.35-6.36h.31l-.29.37-4.79 6-.16.2-.14-.21c-1.63-2.3-3.15-4.44-4.52-6.39h.26l-5.55 6.33-.1.11-.08-.12-1.74-2.93-.45-.78a1.39 1.39 0 0 1-.13-.27s.07.07.18.24l.5.75 1.83 2.87h-.18l5.47-6.41.14-.16.12.17 4.56 6.36h-.31l4.78-6 .29-.37.15-.19.16.19 5.33 6.38H689l4.56-6.36.14-.18.13.18 4.48 6.41h-.16l1.94-2.33.52-.6a1.17 1.17 0 0 1 .14-.21ZM701.79 424.57c0 .11-8 .2-17.92.2s-17.92-.09-17.92-.2 8-.2 17.92-.2 17.92.09 17.92.2ZM703.41 451.7c0 .11-8.72.2-19.47.2s-19.48-.09-19.48-.2 8.72-.2 19.48-.2 19.47.09 19.47.2Z",
    transform: "translate(-23.82 -29.83)"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    id: "xml_svg__Device"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M85.32 74.26h510.89a6.74 6.74 0 0 1 6.74 6.74v326.12a14.57 14.57 0 0 1-14.57 14.57H92.14a14.57 14.57 0 0 1-14.57-14.57V82a7.75 7.75 0 0 1 7.75-7.74Z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M55.6 396h569.21v16.68a13.72 13.72 0 0 1-13.72 13.72H69.32a13.72 13.72 0 0 1-13.72-13.73V396Z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M91.67 88.06h495.7v293.4H91.67z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "m288.47 395.99 7.06 11.24h99.39l6.56-11.24H288.47zM106.38 105.06h467.48v276.4H106.38z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M166.07 403.18c-.24 0-.44-58.86-.44-131.46s.2-131.49.44-131.49.44 58.86.44 131.49-.2 131.46-.44 131.46ZM156.64 164.07c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM157.22 149.15c0 .24-3.4.44-7.59.44s-7.59-.2-7.59-.44 3.4-.44 7.59-.44 7.59.2 7.59.44ZM156.64 180.15c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 196.23c0 .25-3.4.44-7.59.44s-7.6-.19-7.6-.44 3.4-.43 7.6-.43 7.59.2 7.59.43ZM156.64 212.32c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.19 7.59.44ZM156.64 228.4c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 244.48c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 260.56c0 .25-3.4.44-7.59.44s-7.6-.19-7.6-.44 3.4-.43 7.6-.43 7.59.19 7.59.43ZM156.64 276.65c0 .24-3.4.43-7.59.43s-7.6-.19-7.6-.43 3.4-.44 7.6-.44 7.59.19 7.59.44ZM156.64 292.73c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 308.81c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 324.89c0 .25-3.4.44-7.59.44s-7.6-.19-7.6-.44 3.4-.43 7.6-.43 7.59.19 7.59.43ZM156.64 341c0 .24-3.4.43-7.59.43s-7.6-.19-7.6-.43 3.4-.44 7.6-.44 7.59.17 7.59.44ZM156.64 357.06c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 373.14c0 .24-3.4.44-7.59.44s-7.6-.2-7.6-.44 3.4-.44 7.6-.44 7.59.2 7.59.44ZM156.64 389.22c0 .25-3.4.44-7.59.44s-7.6-.19-7.6-.44 3.4-.44 7.6-.44 7.59.22 7.59.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M217.51 163.12c0 .24-8.82.44-19.7.44s-19.71-.2-19.71-.44 8.82-.44 19.71-.44 19.7.2 19.7.44ZM217.51 389.22c0 .25-8.82.44-19.7.44s-19.71-.19-19.71-.44 8.82-.44 19.71-.44 19.7.22 19.7.44ZM272.4 196.23c0 .25-16.51.44-36.87.44s-36.87-.19-36.87-.44 16.5-.43 36.87-.43 36.87.2 36.87.43Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M357.68 196.23c0 .25-16.51.44-36.87.44s-36.88-.19-36.88-.44 16.51-.43 36.88-.43 36.87.2 36.87.43ZM325.09 212.32c0 .24-24.33.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.19 54.34.44ZM325.09 228.4c0 .24-24.33.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.2 54.34.44ZM399.9 276.65c0 .24-24.34.43-54.34.43s-54.35-.19-54.35-.43 24.33-.44 54.35-.44 54.34.19 54.34.44ZM367.61 244.48c0 .24-24.33.44-54.33.44s-54.35-.2-54.35-.44 24.33-.44 54.35-.44 54.33.2 54.33.44ZM500.42 244.48c0 .24-24.33.44-54.33.44s-54.35-.2-54.35-.44 24.33-.44 54.35-.44 54.33.2 54.33.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M454.24 212.32c0 .24-24.34.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.19 54.34.44ZM529.31 276.65c0 .24-24.33.43-54.34.43s-54.34-.19-54.34-.43 24.32-.44 54.34-.44 54.34.19 54.34.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M514.32 228.4c0 .24-37.78.44-84.38.44s-84.38-.2-84.38-.44 37.77-.44 84.38-.44 84.38.2 84.38.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M217.51 180.15c0 .24-8.82.44-19.7.44s-19.71-.2-19.71-.44 8.82-.44 19.71-.44 19.7.2 19.7.44ZM217.51 373.14c0 .24-8.82.44-19.7.44s-19.71-.2-19.71-.44 8.82-.44 19.71-.44 19.7.2 19.7.44ZM237 244.48c0 .24-8.82.44-19.71.44s-19.71-.2-19.71-.44 8.83-.44 19.71-.44 19.71.2 19.71.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M552.93 244.48c0 .24-8.82.44-19.7.44s-19.71-.2-19.71-.44 8.82-.44 19.71-.44 19.7.2 19.7.44ZM272.4 308.72c0 .24-16.51.44-36.87.44s-36.87-.2-36.87-.44 16.5-.44 36.87-.44 36.87.19 36.87.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M357.68 308.72c0 .24-16.51.44-36.87.44s-36.88-.2-36.88-.44 16.51-.44 36.88-.44 36.87.19 36.87.44ZM325.09 324.8c0 .24-24.33.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.2 54.34.44ZM325.09 340.88c0 .24-24.33.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.2 54.34.44ZM367.61 357c0 .25-24.33.44-54.33.44s-54.35-.19-54.35-.44 24.33-.43 54.35-.43 54.33.15 54.33.43ZM500.42 357c0 .25-24.33.44-54.33.44s-54.35-.19-54.35-.44 24.33-.43 54.35-.43 54.33.15 54.33.43Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M454.24 324.8c0 .24-24.34.44-54.34.44s-54.34-.2-54.34-.44 24.32-.44 54.34-.44 54.34.2 54.34.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M514.32 340.88c0 .24-37.78.44-84.38.44s-84.38-.2-84.38-.44 37.77-.44 84.38-.44 84.38.2 84.38.44Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M237 357c0 .25-8.82.44-19.71.44s-19.71-.19-19.71-.44 8.83-.43 19.71-.43 19.71.15 19.71.43Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M552.93 357c0 .25-8.82.44-19.7.44s-19.71-.19-19.71-.44 8.82-.43 19.71-.43 19.7.15 19.7.43Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M563.44 436c0 .14-100.64.26-224.76.26s-224.78-.14-224.78-.26 100.62-.26 224.78-.26 224.76.1 224.76.26Z",
    transform: "translate(-23.82 -29.83)"
  }))), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    id: "xml_svg__Plant"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M97.07 347.83a57.06 57.06 0 0 0-54.45-14.95 99.15 99.15 0 0 0 55.1 17.21M78.6 282.43c2.27-16.05-4-34.1-16-45.76-.39 15.9 6.32 33.79 16 45.76M88.21 312.74a85.64 85.64 0 0 0-39.35-37.61 54.08 54.08 0 0 0 39.5 37.78M90.2 318.58c-9.69.28-19.5-.06-28.87-2.54S43 308.79 36.74 301.37a96.45 96.45 0 0 1 53.31 16.27M85.28 299.32c4.92-18.44 13-31.19 27.53-41.52a38.33 38.33 0 0 1-27.53 41.52M121.86 331.12a27.28 27.28 0 0 0-16.58-25.28c.81 9.52 8.29 20.53 16.58 25.28M126.49 315.57a40.68 40.68 0 0 1 26.64-34.69c-3.35 15.41-12.25 28.24-26.64 34.69M119.51 343.16c3.42-4.89 9-7.93 14.77-9.44s11.8-1.65 17.76-1.77A41.53 41.53 0 0 1 120 345.31M112.59 382.45a45.5 45.5 0 0 1 55.56 26.33C148 405 128.05 396 112.59 382.45M90.44 368.8c3.35 9.91 2.7 21.89-4.75 30.43a36.34 36.34 0 0 1 4.75-30.43M77.34 363.29a37.28 37.28 0 0 1-20.59 30.26 2.34 2.34 0 0 1-1.82.3c-.91-.37-1-1.61-.88-2.59 1.46-12.69 10.87-25 23.29-28M68.79 362a30.58 30.58 0 0 1-44.67.23c14.2-1.55 30.58-2.59 44.67-.23",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M66.66 248.49s0 .15.13.42l.44 1.2c.4 1.08 1 2.62 1.71 4.6s1.65 4.44 2.67 7.29l1.64 4.56 1.75 5.13c2.52 7.19 5.31 15.82 8.33 25.43s6.07 20.25 9.13 31.47 5.69 22 8 31.78 4.12 18.69 5.49 26.19q.53 2.81 1 5.34t.81 4.77c.51 3 .95 5.55 1.25 7.66s.57 3.71.74 4.85q.14.79.21 1.26a2.72 2.72 0 0 0 .09.43 2.43 2.43 0 0 0 0-.44c0-.31-.09-.73-.16-1.26-.15-1.14-.36-2.78-.64-4.87s-.67-4.69-1.16-7.68c-.24-1.49-.5-3.09-.77-4.78s-.63-3.48-1-5.35c-1.33-7.51-3.19-16.39-5.38-26.23S96 339.68 93 328.44 86.82 306.6 83.83 297s-5.88-18.23-8.44-25.4q-1-2.7-1.81-5.13l-1.69-4.55c-1-2.84-2-5.28-2.75-7.26s-1.39-3.49-1.81-4.56c-.21-.5-.37-.89-.48-1.18a3 3 0 0 0-.19-.43Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M144.66 289.11s-.09.07-.25.23l-.68.71c-.59.63-1.45 1.58-2.52 2.83a98.46 98.46 0 0 0-8.36 11.12 74.82 74.82 0 0 0-8.74 18.71c-2.35 7.44-3.8 15.9-5.25 24.75-2.88 17.7-6.43 33.56-9 45-1.29 5.71-2.34 10.34-3.08 13.58-.35 1.57-.62 2.81-.81 3.69-.09.4-.15.72-.2 1a1.05 1.05 0 0 0 0 .33s0-.11.1-.32.15-.56.25-.95l.92-3.67c.77-3.24 1.88-7.85 3.24-13.55 2.66-11.45 6.27-27.3 9.16-45 1.45-8.85 2.88-17.29 5.18-24.7a75.68 75.68 0 0 1 8.59-18.64 108.93 108.93 0 0 1 8.2-11.22c1-1.26 1.88-2.23 2.44-2.88l.64-.75ZM64.55 361.4a1.74 1.74 0 0 0 .51.09l1.47.17 1.06.1 1.26.19c.9.13 1.93.27 3 .51l1.77.36 1.89.47c1.31.3 2.67.78 4.12 1.22a61.35 61.35 0 0 1 9 4 51.22 51.22 0 0 1 8.06 5.6 38.41 38.41 0 0 1 3.09 3 32.77 32.77 0 0 1 2.45 2.82 29.38 29.38 0 0 1 1.81 2.5 17.24 17.24 0 0 1 1.24 2l.75 1.27c.18.29.28.44.3.43a1.56 1.56 0 0 0-.2-.47l-.67-1.33a15.44 15.44 0 0 0-1.17-2 26.41 26.41 0 0 0-1.76-2.56 29.72 29.72 0 0 0-2.42-2.9 40.62 40.62 0 0 0-3.09-3 49.41 49.41 0 0 0-8.1-5.87 58 58 0 0 0-9.1-4c-1.46-.42-2.83-.89-4.16-1.17l-1.91-.45-1.75-.29c-1.13-.23-2.17-.34-3.08-.44l-1.26-.15-1.07-.05-1.48-.06a1.89 1.89 0 0 0-.56.01ZM60.5 289.45a6.82 6.82 0 0 0 1 1l2.95 2.55c2.48 2.12 5.94 5 9.77 8.21s7.34 6 9.88 8.08l3 2.41a8.11 8.11 0 0 0 1.16.82 7.3 7.3 0 0 0-1-1L84.34 309c-2.48-2.12-5.93-5-9.77-8.2s-7.33-6-9.87-8.08l-3-2.41a6.94 6.94 0 0 0-1.2-.86ZM57 308.23c0 .15 7.42 2.47 16.65 5.2s16.77 4.83 16.81 4.69-7.41-2.48-16.65-5.21-16.75-4.82-16.81-4.68ZM84.54 300.75a5.78 5.78 0 0 0 .77-1.07l2-3c1.66-2.52 4-6 6.83-9.63s5.5-6.85 7.48-9.13l2.36-2.69a5.88 5.88 0 0 0 .83-1 6 6 0 0 0-1 .88c-.61.6-1.46 1.48-2.49 2.59-2.07 2.21-4.82 5.38-7.63 9.05s-5.14 7.17-6.73 9.75c-.79 1.29-1.41 2.35-1.82 3.09a7.08 7.08 0 0 0-.6 1.16ZM110.43 311.18a26.69 26.69 0 0 0 1.75 2.88c1.12 1.75 2.63 4.18 4.19 6.93s2.89 5.29 3.82 7.15a25.89 25.89 0 0 0 1.58 3 17.13 17.13 0 0 0-1.23-3.14c-.85-1.9-2.12-4.48-3.7-7.25s-3.14-5.18-4.34-6.88a17.69 17.69 0 0 0-2.07-2.69Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M119.29 343.67c0 .07 1.46-.62 3.79-1.67s5.58-2.42 9.25-3.7 7.07-2.25 9.55-2.88 4-1 4-1.05a4 4 0 0 0-1.11.11c-.71.11-1.73.3-3 .57a82.77 82.77 0 0 0-18.87 6.6c-1.15.57-2.07 1.06-2.69 1.42a4.31 4.31 0 0 0-.92.6ZM112.32 382.51s.15.08.46.16l1.34.34 5 1.15a162.32 162.32 0 0 1 16.19 4.27 71.7 71.7 0 0 1 15.11 7.1c1.81 1.15 3.22 2.17 4.17 2.9a16.14 16.14 0 0 0 1.5 1.11s-.11-.14-.34-.36-.57-.54-1-.92a45 45 0 0 0-4.09-3.05 66.09 66.09 0 0 0-15.14-7.29 135.27 135.27 0 0 0-16.29-4.14l-5-1a15.25 15.25 0 0 0-1.91-.27ZM87.1 392.09c.15 0 1-5.21 2-11.68s1.6-11.74 1.45-11.76-1 5.21-2 11.68-1.55 11.74-1.45 11.76ZM60.84 382.56a27.72 27.72 0 0 0 2.37-2.81c1.42-1.77 3.38-4.2 5.61-6.85s4.28-5 5.78-6.7a29.16 29.16 0 0 0 2.4-2.82 3.73 3.73 0 0 0-.76.65c-.46.43-1.1 1.09-1.89 1.91-1.57 1.64-3.68 4-5.91 6.61s-4.15 5.13-5.49 7c-.68.92-1.21 1.67-1.56 2.19a3.65 3.65 0 0 0-.55.82Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M106.5 377.07v12.98h-3.24l-11.53 36.39H66.16L54.98 390.4l-4.32-.35v-12.98h55.84z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M106.5 377.07v12.98h-3.24l-11.53 36.39H66.16L54.98 390.4l-4.32-.35v-12.98h55.84z",
    className: "xml_svg__cls-3"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M76.64 420.24c0 .15 11.3.27 25.22.27s25.22-.12 25.22-.27-11.29-.27-25.22-.27-25.22.12-25.22.27ZM58.25 336.79a10 10 0 0 0 1.64.44l4.49 1.09c3.78.93 9 2.35 14.61 4.25s10.64 3.9 14.22 5.44l4.23 1.85a10.75 10.75 0 0 0 1.57.64 9.92 9.92 0 0 0-1.48-.83c-1-.5-2.39-1.19-4.17-2a150.22 150.22 0 0 0-14.19-5.61 147.14 147.14 0 0 0-14.7-4.11c-1.91-.42-3.46-.73-4.54-.91a9.54 9.54 0 0 0-1.68-.25Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M85.13 440.45c0 .15 7.93.27 17.7.27s17.69-.12 17.69-.27-7.92-.27-17.69-.27-17.7.12-17.7.27ZM84.14 437.44c0 .15 8.4.27 18.75.27s18.75-.12 18.75-.27-8.39-.27-18.75-.27-18.75.12-18.75.27Z",
    transform: "translate(-23.82 -29.83)"
  }))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M709.46 456.48c0 .15-152.44.27-340.44.27s-340.48-.12-340.48-.27 152.46-.26 340.46-.26 340.46.12 340.46.26Z",
    transform: "translate(-23.82 -29.83)",
    id: "xml_svg__Floor"
  })), _g4 || (_g4 = /*#__PURE__*/react.createElement("g", {
    id: "xml_svg__Speech_Bubbles",
    "data-name": "Speech Bubbles"
  }, /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M592.21 46.29H324.23v165.97h225.6l13.96 32.13 12.39-32.13h16.03V46.29z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M616 76.12c0 1.61.07 64 .2 166v.2H600l.19-.13c-3.87 10.07-8.05 20.92-12.37 32.13l-.19.51-.22-.5c-4.38-10.06-9.11-20.95-14-32.13l.21.14H347.79V75.84h.24l268 .23-268 .24.24-.23v166l-.26-.26h225.73l.06.14 14 32.14h-.41l12.42-32.1.05-.14H616l-.2.2c.2-101.98.2-164.33.2-165.94Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M615.9 92.32c0 .2-59.88.37-133.72.37s-133.73-.17-133.73-.37S408.32 92 482.18 92s133.72.12 133.72.32ZM362.29 85a2.2 2.2 0 1 1-2.19-2.2 2.2 2.2 0 0 1 2.19 2.2ZM370.24 85a2.2 2.2 0 1 1-2.19-2.2 2.2 2.2 0 0 1 2.19 2.2ZM378.19 85a2.2 2.2 0 1 1-2.2-2.2 2.2 2.2 0 0 1 2.2 2.2ZM377.28 122l-6.36 2.46 6.36 2.45v1.49l-8-3.17v-1.53l8-3.18ZM383.9 115.65h1.56l-5.92 16.88H378ZM394 123.7v1.54l-8 3.17v-1.49l6.38-2.45L386 122v-1.49ZM396.06 129.61a1.2 1.2 0 0 1 1.22-1.22 1.18 1.18 0 0 1 1.19 1.22 1.2 1.2 0 0 1-1.19 1.24 1.22 1.22 0 0 1-1.22-1.24ZM400.14 129.61a1.19 1.19 0 0 1 1.22-1.22 1.18 1.18 0 0 1 1.18 1.22 1.2 1.2 0 0 1-1.18 1.24 1.21 1.21 0 0 1-1.22-1.24ZM404.21 129.61a1.19 1.19 0 0 1 1.22-1.22 1.18 1.18 0 0 1 1.18 1.22 1.2 1.2 0 0 1-1.18 1.24 1.21 1.21 0 0 1-1.22-1.24Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M546.5 145.71c0 .2-39.61.36-88.47.36s-88.48-.16-88.48-.36 39.61-.37 88.48-.37 88.47.16 88.47.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M575.4 146.23c0 .2-3.8.37-8.5.37s-8.5-.17-8.5-.37 3.81-.37 8.5-.37 8.5.14 8.5.37ZM600.25 146.23c0 .2-4.16.37-9.28.37s-9.29-.17-9.29-.37 4.16-.37 9.29-.37 9.28.14 9.28.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M482.23 160.62c0 .2-25.18.36-56.24.36s-56.23-.16-56.23-.36 25.17-.37 56.23-.37 56.24.16 56.24.37ZM481.42 216.25c0 .2-25.18.36-56.23.36s-56.24-.16-56.24-.36 25.18-.37 56.24-.37 56.23.17 56.23.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M523.09 160.62c0 .2-6.85.36-15.3.36s-15.3-.16-15.3-.36 6.85-.37 15.3-.37 15.3.16 15.3.37ZM522.77 216.25c0 .2-6.85.36-15.3.36s-15.3-.16-15.3-.36 6.85-.37 15.3-.37 15.3.17 15.3.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M377.14 168.2c0 .2-1.7.37-3.8.37s-3.79-.17-3.79-.37 1.7-.36 3.79-.36 3.8.16 3.8.36Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M403.29 168.36c0 .2-3.69.36-8.24.36s-8.24-.16-8.24-.36 3.69-.37 8.24-.37 8.24.17 8.24.37ZM420 168.36c0 .2-3.16.36-7.06.36s-7.06-.16-7.06-.36 3.16-.37 7.06-.37 7.06.17 7.06.37ZM441.22 168.36c0 .2-3.22.36-7.19.36s-7.2-.16-7.2-.36 3.22-.37 7.2-.37 7.19.17 7.19.37ZM459.79 168.36c0 .2-2.93.36-6.54.36s-6.54-.16-6.54-.36 2.93-.37 6.54-.37 6.54.17 6.54.37ZM521.26 168.36c0 .2-12.88.36-28.77.36s-28.78-.16-28.78-.36 12.88-.37 28.78-.37 28.77.17 28.77.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M376.09 177.88c0 .2-1.46.37-3.27.37s-3.27-.17-3.27-.37 1.46-.37 3.27-.37 3.27.17 3.27.37ZM376.35 187.82c0 .2-1.52.37-3.4.37s-3.4-.17-3.4-.37 1.52-.37 3.4-.37 3.4.17 3.4.37ZM376.35 199.07c0 .2-1.52.36-3.4.36s-3.4-.16-3.4-.36 1.52-.37 3.4-.37 3.4.16 3.4.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M438.34 198.54c0 .21-11.36.37-25.37.37s-25.37-.16-25.37-.37 11.36-.36 25.37-.36 25.37.16 25.37.36ZM433.9 187.82c0 .2-10.84.37-24.2.37s-24.19-.17-24.19-.37 10.83-.37 24.19-.37 24.2.17 24.2.37ZM550.82 177.36c0 .2-36.9.36-82.39.36s-82.4-.16-82.4-.36 36.88-.37 82.4-.37 82.39.16 82.39.37Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-9",
    d: "M608.68 114.16V255.2l-21.93 18.3h114.69V114.16h-92.76z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M632.5 144h24.89l67.87-.1h.2v.2c0 42.57 0 98.17.06 159.33v.26H609.91l.51-.43 21.94-18.29-.09.18.12-102.2c0-12.35.05-22.07.06-28.71v-10.13 10.27c0 6.65 0 16.39.06 28.75 0 24.72.06 60 .11 102.06v.1l-.08.07-21.92 18.31-.16-.43h114.69l-.26.26c0-61.16 0-116.76.06-159.33l.2.19-67.75-.1L639 144h-4.84Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M640.93 151a1.88 1.88 0 1 1-1.88-1.88 1.88 1.88 0 0 1 1.88 1.88ZM647.73 151a1.88 1.88 0 1 1-1.88-1.88 1.88 1.88 0 0 1 1.88 1.88ZM654.53 151a1.88 1.88 0 1 1-1.88-1.88 1.88 1.88 0 0 1 1.88 1.88Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M699.76 194.47c0 .17-11.76.3-26.26.3s-26.26-.13-26.26-.3 11.75-.3 26.26-.3 26.26.13 26.26.3ZM710.72 207.23c0 .16-14.31.3-32 .3s-32-.14-32-.3 14.31-.3 32-.3 32 .13 32 .3ZM713.32 254.83c0 .17-15.26.3-34.08.3s-34.08-.13-34.08-.3 15.26-.3 34.08-.3 34.08.14 34.08.3ZM652.16 213.72a17.7 17.7 0 0 1-6.49 0 17.7 17.7 0 0 1 6.49 0ZM674.55 213.85c0 .17-3.16.3-7 .3s-7-.13-7-.3a83 83 0 0 1 14.1 0ZM688.87 213.85c0 .17-2.7.3-6 .3s-6.05-.13-6.05-.3a61.05 61.05 0 0 1 12.09 0ZM651.27 222a13.22 13.22 0 0 1-5.6 0 13.22 13.22 0 0 1 5.6 0ZM651.49 230.51a14.26 14.26 0 0 1-5.82 0 13.81 13.81 0 0 1 5.82 0ZM651.49 240.13a14.26 14.26 0 0 1-5.82 0 14.26 14.26 0 0 1 5.82 0ZM704.54 239.68c0 .17-9.72.3-21.71.3s-21.71-.13-21.71-.3 9.72-.3 21.71-.3 21.71.14 21.71.3ZM700.73 230.51c0 .16-9.27.3-20.7.3s-20.7-.14-20.7-.3 9.26-.31 20.7-.31 20.7.14 20.7.31ZM655.73 267.54a14.26 14.26 0 0 1-5.82 0 14.26 14.26 0 0 1 5.82 0ZM655.73 277.17a14.26 14.26 0 0 1-5.82 0 13.81 13.81 0 0 1 5.82 0ZM708.78 276.72c0 .16-9.72.3-21.71.3s-21.71-.14-21.71-.3 9.71-.3 21.71-.3 21.71.13 21.71.3ZM705 267.54c0 .17-9.27.3-20.7.3s-20.71-.13-20.71-.3 9.27-.3 20.71-.3 20.7.13 20.7.3ZM716.13 221.55c0 .17-12.62.3-28.18.3s-28.18-.13-28.18-.3 12.62-.3 28.18-.3 28.18.14 28.18.3Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M724.39 158.38c0 .16-20.37.3-45.49.3s-45.49-.14-45.49-.3 20.36-.3 45.49-.3 45.49.13 45.49.3Z",
    transform: "translate(-23.82 -29.83)"
  }), /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M666.43 186.78a154.07 154.07 0 0 1-19.22 0c0-.17 4.3-.3 9.61-.3s9.61.13 9.61.3ZM655.55 169.37c0 .17-2 .3-4.53.3s-4.53-.13-4.53-.3a34.35 34.35 0 0 1 9.06 0Z",
    transform: "translate(-23.82 -29.83)"
  }))), /*#__PURE__*/react.createElement("g", {
    id: "xml_svg__Character"
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "m575.27 374.76 20.14-19.91-35.92-61.51a34.66 34.66 0 0 0-13.78-9.59l-12.65-4.81-31.45-5.77-22.32 8.83a13.35 13.35 0 0 0-8.37 14l5.84 49.16 3.44 64 81.13-14.08-8.16-23.67.27-36.92Z",
    transform: "translate(-23.82 -29.83)"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M553.91 369.82c.19 0 .24-12.79.11-28.56s-.38-28.56-.57-28.56-.24 12.79-.11 28.56.38 28.56.57 28.56Z",
    transform: "translate(-23.82 -29.83)"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "m550.94 379.2-49-19.73a11.23 11.23 0 0 1-7-9.54l-3.58-47s.42-20-12.06-21l-7.11 2.79C463 289.64 460.73 303 462 313.32c1.77 14.66 2.51 35.41 4.5 48.14 1.63 10.41 7.88 18.64 17.78 22.25l60.38 13.07Z",
    transform: "translate(-23.82 -29.83)"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M492.05 310.1a7.87 7.87 0 0 1 .15 1.07c.08.77.19 1.8.32 3.1.25 2.75.6 6.63 1 11.4s.9 10.56 1.45 16.91c.13 1.59.27 3.22.41 4.89a37.58 37.58 0 0 0 .63 5 8.35 8.35 0 0 0 2.43 4.4 16.45 16.45 0 0 0 4.53 2.81c13.51 5.85 26 10.68 35 14.07l10.74 4 2.92 1.07a5.79 5.79 0 0 1 1 .42 7.52 7.52 0 0 1-1-.29l-3-1c-2.57-.85-6.27-2.13-10.82-3.76-9.09-3.29-21.57-8-35.13-13.91a17.13 17.13 0 0 1-4.7-2.94 8.92 8.92 0 0 1-2.61-4.73 37.2 37.2 0 0 1-.62-5.12q-.21-2.5-.39-4.89c-.5-6.36-.94-12.09-1.32-16.93s-.62-8.65-.83-11.41c-.08-1.3-.14-2.34-.19-3.11a8 8 0 0 1 .03-1.05ZM464 335.65a1.86 1.86 0 0 1 .1.63c0 .49.1 1.09.16 1.81.15 1.68.35 3.93.58 6.67s.61 6.16 1.1 9.86a94.25 94.25 0 0 0 2.22 11.91 17.56 17.56 0 0 0 2.39 5.67 32.43 32.43 0 0 0 3.66 4.5 31.28 31.28 0 0 0 7.85 5.89 29.56 29.56 0 0 0 8.61 2.82 2.85 2.85 0 0 1-.64 0 13.08 13.08 0 0 1-1.82-.23 24.1 24.1 0 0 1-6.41-2.18 30.88 30.88 0 0 1-8.06-5.87 31.8 31.8 0 0 1-3.76-4.57 18.16 18.16 0 0 1-2.5-5.86 89.82 89.82 0 0 1-2.18-12c-.45-3.72-.75-7.08-1-9.9s-.31-5.11-.37-6.69v-1.83a2.58 2.58 0 0 1 .07-.63Z",
    transform: "translate(-23.82 -29.83)"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M484.93 368.54a7.13 7.13 0 0 1 .89-2.62 16.81 16.81 0 0 1 9.94-8.49 7.15 7.15 0 0 1 2.72-.47c0 .11-1 .31-2.56.91a19.59 19.59 0 0 0-5.56 3.3 19.29 19.29 0 0 0-4.13 5c-.84 1.42-1.23 2.4-1.3 2.37Z",
    transform: "translate(-23.82 -29.83)"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M536.85 373.6c-5.24-3-10.37-5.24-15.85-7.73s-10.85-5.69-14.43-10.52c-6.77-9.12-6-22.28-12.92-31.28l1.35 18.15c.42 5.55-.43 11 3.14 14.8 3 3.17 8.88 5.61 13 7 8.35 2.75 17.34 6.84 25.68 9.6",
    transform: "translate(-23.82 -29.83)",
    className: "xml_svg__cls-3"
  })), /*#__PURE__*/react.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "m529.63 286.33 4.24 26.15-4.01-7.41-.23-18.74z"
  }), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M490.57 300a4.25 4.25 0 0 1-1.13.09l-3.1.08c-2.61.07-6.21.2-10.18.48s-7.55.67-10.15 1l-3.07.36a5.6 5.6 0 0 1-1.13.08 4 4 0 0 1 1.1-.28c.72-.15 1.76-.33 3-.53 2.59-.4 6.18-.84 10.16-1.13s7.6-.36 10.22-.33c1.31 0 2.37.05 3.1.09a5.46 5.46 0 0 1 1.18.09ZM492 325.06c0 .14-6.42.79-14.35 1.44s-14.39 1.08-14.4.93 6.41-.79 14.35-1.45 14.4-1.07 14.4-.92ZM494.33 351.37a5.35 5.35 0 0 1-1 .58c-.67.35-1.65.81-2.9 1.33a59.94 59.94 0 0 1-20.43 4.58c-1.35.06-2.44.06-3.19 0a4.39 4.39 0 0 1-1.16-.09 5.73 5.73 0 0 1 1.16-.11c.75 0 1.83-.09 3.17-.2a73.76 73.76 0 0 0 10.3-1.46 72.85 72.85 0 0 0 10-3c1.25-.48 2.26-.88 3-1.17a5 5 0 0 1 1.05-.46ZM511.76 364.87a25.72 25.72 0 0 0-4.86 3.9 27.16 27.16 0 0 0-3.39 5.23 5 5 0 0 1 .54-1.79 14.27 14.27 0 0 1 6-6.62 4.63 4.63 0 0 1 1.71-.72ZM529.49 382.19a19.05 19.05 0 0 1 5.24-9.56c.12.1-1.42 2-2.86 4.65s-2.23 4.96-2.38 4.91ZM501.55 285.3a49.44 49.44 0 0 1-6.93 1.52 48.7 48.7 0 0 1-7 1 47.4 47.4 0 0 1 6.93-1.52 48.7 48.7 0 0 1 7-1ZM548.48 287.44a90.29 90.29 0 0 1-9.62-.88 87.75 87.75 0 0 1-9.55-1.4 93.55 93.55 0 0 1 9.62.88 90.79 90.79 0 0 1 9.55 1.4ZM552.48 309.26a2.07 2.07 0 0 1-.61 0h-8.23c-5.46 0-13 0-21.33.25s-15.86.56-21.32.85l-6.46.34-1.75.07a2.09 2.09 0 0 1-.62 0 3.38 3.38 0 0 1 .61-.09l1.75-.18c1.52-.14 3.72-.31 6.45-.5 5.45-.38 13-.78 21.33-1s15.88-.2 21.35-.1c2.73.05 4.94.11 6.46.18l1.76.08a3.27 3.27 0 0 1 .61.1ZM553.06 336.91c0 .14-12.85 1.1-28.72 2.15s-28.75 1.77-28.76 1.63 12.85-1.11 28.72-2.15 28.75-1.78 28.76-1.63ZM551.69 361.26a5.76 5.76 0 0 1-1.08.46c-.71.27-1.74.62-3 1-2.57.84-6.16 1.89-10.17 2.86s-7.68 1.66-10.35 2.07c-1.34.22-2.42.37-3.17.45a6.08 6.08 0 0 1-1.18.08 5.34 5.34 0 0 1 1.15-.28l3.13-.61c2.65-.51 6.3-1.26 10.3-2.22s7.59-1.95 10.18-2.7l3.07-.89a4.64 4.64 0 0 1 1.12-.22ZM572.26 317.12a89.43 89.43 0 0 1-9.34 2.68 91.06 91.06 0 0 1-9.47 2.18 91.28 91.28 0 0 1 9.34-2.68 88.66 88.66 0 0 1 9.47-2.18ZM562.45 298.43a17.11 17.11 0 0 1-4.13 1 17.61 17.61 0 0 1-4.24.5 18 18 0 0 1 4.14-1 17.55 17.55 0 0 1 4.23-.5Z",
    transform: "translate(-23.82 -29.83)"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M492.2 304.23c-.1 0-.26-1.66-1.17-4.17a21.11 21.11 0 0 0-14.86-13.36c-2.6-.64-4.29-.61-4.28-.71a4.38 4.38 0 0 1 1.18-.05 18.31 18.31 0 0 1 3.18.41 20.34 20.34 0 0 1 15.12 13.59 17.14 17.14 0 0 1 .74 3.12 4.3 4.3 0 0 1 .09 1.17ZM550.6 290.9a80.32 80.32 0 0 1 1.73 9.14 80.84 80.84 0 0 1 1.21 9.23 84.48 84.48 0 0 1-1.72-9.15 82.68 82.68 0 0 1-1.22-9.22Z",
    transform: "translate(-23.82 -29.83)"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M605.24 438.29s37.68 10.42 39.19 11c2.27.8 1.89 9.11-1.64 9-1.67-.06-28.94 1-32.39.8s-13.84-4.31-13.84-4.31Z",
    transform: "translate(-23.82 -29.83)"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M620.94 452.66c.19 0 .44-2 1.66-4s2.78-3.32 2.66-3.47-1.94.92-3.21 3.15-1.27 4.34-1.11 4.32ZM617 450.88c.18 0 .56-1.75 1.57-3.72s2.19-3.34 2-3.47a7.18 7.18 0 0 0-2.62 3.19c-.95 2.12-1.1 3.99-.95 4ZM613.32 449.9c.19 0 0-1.9.88-4s2.19-3.38 2.06-3.52-1.77 1-2.64 3.3-.45 4.32-.3 4.22Z",
    transform: "translate(-23.82 -29.83)"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M614 445a6.72 6.72 0 0 0 .41-2.81 13.56 13.56 0 0 0-.39-3.07 11.78 11.78 0 0 0-.56-1.75 2.09 2.09 0 0 0-.6-.92 1 1 0 0 0-1.29.06 1.67 1.67 0 0 0-.51 1.07 8.45 8.45 0 0 0 0 1 7.81 7.81 0 0 0 .23 1.85 11.43 11.43 0 0 0 1.16 2.88 7.78 7.78 0 0 0 1.69 2.27c.09-.06-.54-.94-1.3-2.48a12.81 12.81 0 0 1-1-2.8 8.64 8.64 0 0 1-.18-1.72c0-.58 0-1.3.35-1.58a.36.36 0 0 1 .5 0 1.5 1.5 0 0 1 .41.66 13.07 13.07 0 0 1 .57 1.66 14.94 14.94 0 0 1 .5 2.94c.07 1.74-.1 2.74.01 2.74Z",
    transform: "translate(-23.82 -29.83)"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M614 444.65a5.27 5.27 0 0 0-2.44-.4 11 11 0 0 0-2.67.33 5.82 5.82 0 0 0-1.54.57 1.6 1.6 0 0 0-.85 1.72 1.86 1.86 0 0 0 1.36 1.34 3.45 3.45 0 0 0 1.69 0A6.68 6.68 0 0 0 612 447a6.92 6.92 0 0 0 1.75-1.73 16.4 16.4 0 0 0-2 1.36 6.62 6.62 0 0 1-2.31 1 2.88 2.88 0 0 1-1.4 0 1.29 1.29 0 0 1-.92-.89 1 1 0 0 1 .56-1.06 6 6 0 0 1 1.37-.53 12.79 12.79 0 0 1 2.54-.44c1.41-.11 2.34.04 2.41-.06ZM626.73 453.07c.18 0 0-1.63.74-3.4s2-2.81 1.84-2.95-1.63.74-2.42 2.71-.32 3.7-.16 3.64ZM600.44 454.81a7.66 7.66 0 0 0 1.45.68 31.53 31.53 0 0 0 4.2 1.3 59.68 59.68 0 0 0 14.38 1.36c5.65-.06 10.74-.31 14.43-.46l4.36-.23a8.44 8.44 0 0 0 1.6-.17 7.29 7.29 0 0 0-1.61-.08h-4.37l-14.41.28a67.89 67.89 0 0 1-14.29-1.16c-3.6-.71-5.7-1.64-5.74-1.52Z",
    transform: "translate(-23.82 -29.83)"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M599.32 455.67c0 .08 1.08-.52 2.82-1.28a13.08 13.08 0 0 1 7.13-1.19 11.31 11.31 0 0 1 6.17 3.67 22.57 22.57 0 0 0 2.17 2.22 11.68 11.68 0 0 0-1.85-2.53 15 15 0 0 0-2.49-2.33 9 9 0 0 0-3.9-1.65A12.44 12.44 0 0 0 602 454a9.84 9.84 0 0 0-2.68 1.67Z",
    transform: "translate(-23.82 -29.83)"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M560.65 429.54s-35.65 23.34-36.94 24.31c-1.92 1.45.28 8.36 3.61 7.16 1.57-.56 31.49-8.89 34.71-10.14s11.88-8.31 11.88-8.31Z",
    transform: "translate(-23.82 -29.83)"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M550.06 448c.15 0-.48-2.09-2.39-3.81s-4-2.19-4-2 1.82.86 3.59 2.49 2.63 3.41 2.8 3.32ZM553.26 445.11c.15-.05-.54-1.85-2.17-3.5s-3.4-2.4-3.46-2.25 1.47 1.1 3 2.69 2.46 3.15 2.63 3.06ZM556.47 443.05c.16 0 0-2-1.56-3.92s-3.48-2.49-3.51-2.33 1.62 1 3 2.73 1.89 3.57 2.07 3.52Z",
    transform: "translate(-23.82 -29.83)"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M554.36 438.62c.09 0-.4-1-.81-2.67a15.59 15.59 0 0 1-.42-2.95 15 15 0 0 1 0-1.76 1.59 1.59 0 0 1 .19-.75.37.37 0 0 1 .49-.11c.41.16.62.85.81 1.4a8.08 8.08 0 0 1 .35 1.69 12.35 12.35 0 0 1-.09 3c-.25 1.69-.58 2.72-.48 2.75a7.59 7.59 0 0 0 .92-2.67 11.38 11.38 0 0 0 .23-3.1 8.16 8.16 0 0 0-.34-1.83 7.61 7.61 0 0 0-.35-.93 1.66 1.66 0 0 0-.8-.86 1 1 0 0 0-1.25.33 2.17 2.17 0 0 0-.3 1.06 14.11 14.11 0 0 0 0 1.84 12.86 12.86 0 0 0 .57 3 6.54 6.54 0 0 0 1.28 2.56Z",
    transform: "translate(-23.82 -29.83)"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M554.28 438.24c.05.09.88-.33 2.32-.68a12.87 12.87 0 0 1 2.55-.35 6 6 0 0 1 1.47.09 1 1 0 0 1 .85.83 1.3 1.3 0 0 1-.6 1.14 3 3 0 0 1-1.33.44 6.61 6.61 0 0 1-2.5-.25 17.91 17.91 0 0 0-2.33-.69 6.53 6.53 0 0 0 2.2 1.11 6.43 6.43 0 0 0 2.69.41 3.56 3.56 0 0 0 1.62-.51 1.89 1.89 0 0 0 .88-1.7 1.59 1.59 0 0 0-1.33-1.38 6.18 6.18 0 0 0-1.64-.07 11 11 0 0 0-2.65.5 5.46 5.46 0 0 0-2.2 1.11ZM531.86 459.71c0 .06.6-.36.88-1.38a5.25 5.25 0 0 0-.67-3.87 13.44 13.44 0 0 0-1.2-1.78 6.38 6.38 0 0 0-1.21-1.3 2.19 2.19 0 0 0-1.14-.48c-.29 0-.45.06-.44.1a3.4 3.4 0 0 1 1.3.72 8.54 8.54 0 0 1 1 1.3 20.12 20.12 0 0 1 1.12 1.74 5.56 5.56 0 0 1 .78 3.48 14.06 14.06 0 0 1-.42 1.47ZM544.66 450.15c.17 0 .12-1.8-1.25-3.42s-3.13-2-3.14-1.84 1.44.76 2.65 2.25 1.56 3.04 1.74 3.01Z",
    transform: "translate(-23.82 -29.83)"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M570.24 443.82a11.36 11.36 0 0 0-1.57 1.08 45.45 45.45 0 0 1-4.39 2.69 58.48 58.48 0 0 1-7 3.11c-2.7 1-5.73 1.95-8.93 2.88-6.42 1.85-12.23 3.54-16.42 4.8l-5 1.52a10.26 10.26 0 0 0-1.79.64 11.91 11.91 0 0 0 1.86-.41l5-1.32c4.22-1.15 10-2.77 16.46-4.62 3.21-.93 6.25-1.9 9-2.95a52.78 52.78 0 0 0 7-3.26 34.3 34.3 0 0 0 4.33-2.89 9.16 9.16 0 0 0 1.45-1.27Z",
    transform: "translate(-23.82 -29.83)"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M571.56 444.3a9.71 9.71 0 0 0-3-.8 12.46 12.46 0 0 0-7.49.91 9 9 0 0 0-3.21 2.76 15 15 0 0 0-1.67 3 11.68 11.68 0 0 0-1 3 22.07 22.07 0 0 0 1.39-2.77c.85-1.66 2.19-4.09 4.76-5.37a13.2 13.2 0 0 1 7.16-1c1.88.11 3.04.37 3.06.27ZM634.77 371.16S645.46 375 645.51 387c.08 23-46.42 48.3-46.42 48.3l-61.89-41-3.88-1.57s83.54-31.42 101.45-21.57Z",
    transform: "translate(-23.82 -29.83)"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M568.55 415a10.06 10.06 0 0 0 1.61-1.09c1-.73 2.46-1.83 4.24-3.2 3.54-2.73 8.36-6.62 13.55-11.07s9.75-8.63 13-11.72c1.62-1.54 2.92-2.81 3.8-3.7a10.46 10.46 0 0 0 1.32-1.43 12.11 12.11 0 0 0-1.49 1.25l-3.93 3.55c-3.32 3-7.93 7.13-13.11 11.57s-9.94 8.38-13.41 11.21l-4.13 3.32a11.92 11.92 0 0 0-1.45 1.31ZM617.3 379.74a12.32 12.32 0 0 0-6 .55c-3.23.94-5.4 2.66-5.3 2.78s2.36-1.27 5.48-2.18 5.82-.95 5.82-1.15Z",
    transform: "translate(-23.82 -29.83)"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M612 376.12a7.59 7.59 0 0 0-3.66 2.76c-1.65 2-2.09 4.15-1.93 4.17s.86-1.86 2.42-3.77 3.23-2.99 3.17-3.16Z",
    transform: "translate(-23.82 -29.83)"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M638.17 448.87c0-.07-.74-.22-1.6.48a5.78 5.78 0 0 0-1.78 3.59 6.93 6.93 0 0 0 .56 4c.44.94.92 1.39 1 1.34s-.25-.58-.56-1.5a8.17 8.17 0 0 1-.35-3.71 6.21 6.21 0 0 1 1.46-3.35c.63-.72 1.28-.72 1.27-.85Z",
    transform: "translate(-23.82 -29.83)"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-2",
    d: "M630.34 338.53 612.74 386a6.84 6.84 0 0 1-6.5 4.46l-96.92-1.28v-7.36l36 1.31 15.26-47.34a3.88 3.88 0 0 1 3.69-2.68l62.52.18a3.87 3.87 0 0 1 3.55 5.24Z",
    transform: "translate(-23.82 -29.83)"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M630.34 338.53v-.15a2.57 2.57 0 0 0 .12-.44 3.75 3.75 0 0 0 0-1.79 3.8 3.8 0 0 0-3.46-2.84h-62.16a4.25 4.25 0 0 0-2.58.57 3.79 3.79 0 0 0-1.61 2.11l-15.22 47.26v.11h-.12l-36-1.3.16-.16v7.36l-.15-.15 60.94.81 26.49.37 6.11.08h3a7 7 0 0 0 2.81-.41 6.67 6.67 0 0 0 3.89-3.74c.64-1.72 1.27-3.41 1.89-5.05 4.91-13.17 8.88-23.81 11.62-31.17 1.38-3.66 2.44-6.51 3.17-8.45s1.12-2.93 1.12-2.93-.35 1-1.06 3l-3.14 8.38c-2.72 7.37-6.65 18-11.53 31.2l-1.88 5.07a6.92 6.92 0 0 1-4 3.87 7.36 7.36 0 0 1-2.91.44h-3l-6.1-.08-26.49-.33-60.95-.79h-.15v-7.68h.16l36 1.32-.15.11 15.26-47.25a4 4 0 0 1 1.72-2.25 4.51 4.51 0 0 1 2.72-.6h15.66l18.27.08 26.08.12h2.16a3.88 3.88 0 0 1 3.51 2.93 3.71 3.71 0 0 1 0 1.8 3.52 3.52 0 0 1-.2.57Z",
    transform: "translate(-23.82 -29.83)"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-1",
    d: "M587.37 356.46a4.36 4.36 0 0 1 4.71.5 3.83 3.83 0 0 1 .92 4.18 4.12 4.12 0 0 1-3.54 2.47 3.71 3.71 0 0 1-3.74-2.47c-.45-1.55 0-3.86 1.65-4.68",
    transform: "translate(-23.82 -29.83)"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M609.52 437.85s-87.34-55.94-91.19-58.14c-3.28-1.87-12.06-7.27-20.71-4.88s-16.41 10.17-20.29 21.48c-2.21 6.48-3.26 17.53-3.75 25.82a38.3 38.3 0 0 0 9 27.31 24.53 24.53 0 0 0 10.9 7.74c.91.28 1.86.52 2.83.73 16.53 3.59 33.52-3.83 42.81-18l2-3.1s57.2 21 58.09 20.71Z",
    transform: "translate(-23.82 -29.83)"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M522.84 382.81s-.08 0-.22-.13l-.61-.42c-.54-.37-1.33-.91-2.36-1.58a46.84 46.84 0 0 0-9.28-4.71 24.74 24.74 0 0 0-7-1.47 20 20 0 0 0-8 1.31 25.72 25.72 0 0 0-7.72 4.68 35.13 35.13 0 0 0-3.43 3.37 24.71 24.71 0 0 0-2.84 4 41 41 0 0 0-3.76 9c-.83 3.05-1.49 6.06-2.11 8.9a80.91 80.91 0 0 0-2 15.32 55.61 55.61 0 0 0 .79 10.39c.19 1.22.41 2.15.54 2.79l.14.73a.79.79 0 0 1 0 .25 1.29 1.29 0 0 1-.08-.24c0-.19-.12-.43-.19-.72-.17-.63-.42-1.55-.64-2.77a51.94 51.94 0 0 1-1-10.43 78.53 78.53 0 0 1 1.93-15.39c.62-2.86 1.26-5.85 2.08-8.94a42.14 42.14 0 0 1 3.81-9.12 25.53 25.53 0 0 1 2.9-4.11 35.13 35.13 0 0 1 3.49-3.42 26.21 26.21 0 0 1 7.88-4.74 20.4 20.4 0 0 1 8.23-1.3 25.39 25.39 0 0 1 7.08 1.56 43.87 43.87 0 0 1 9.27 4.89c1 .7 1.79 1.27 2.31 1.67l.58.46a.88.88 0 0 1 .21.17Z",
    transform: "translate(-23.82 -29.83)"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-6",
    d: "M501.35 422.06a4.66 4.66 0 0 0 .48.22l1.43.56 5.54 2.16 20.6 7.76c8.75 3.26 19.24 7.15 31 11.43s24.79 9 38.71 13.68l.26.08.12-.23c2.18-4.18 4.49-8.58 6.83-13.05l3.48-6.67.14-.26-.25-.15L543 395.25l-20-12.64-5.44-3.4-1.42-.86a5.35 5.35 0 0 0-.49-.28s.15.12.46.33l1.39.92 5.38 3.49 19.93 12.8 66.58 42.51-.11-.41c-1.1 2.11-2.28 4.37-3.48 6.65l-6.82 13.05.37-.16c-13.91-4.7-26.95-9.37-38.72-13.61l-31-11.29-20.67-7.58-5.58-2-1.45-.51Z",
    transform: "translate(-23.82 -29.83)"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M505.87 236.47a44.87 44.87 0 0 1-3.88-9.29 15.13 15.13 0 0 1 .52-9.88c.81-1.79 2.09-3.36 2.73-5.22.87-2.56.51-5.58 2.1-7.77 2.47-3.43 7.77-2.63 11.6-4.42 3-1.4 5.07-4.41 8.2-5.42 2.74-.88 5.73 0 8.37 1.1s5.23 2.57 8.08 2.94a54.84 54.84 0 0 0 6.15 0 8.09 8.09 0 0 1 5.67 2c1.44 1.45 1.74 4.14.18 5.47 3.59-.61 7 3 6.92 6.61s-2.79 6.84-6.1 8.36-7.08 1.61-10.71 1.32c-10.27-.8-20.59-4.7-27.58-12.26",
    transform: "translate(-23.82 -29.83)"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-11",
    d: "m508.08 223.62-7 50.85a15.26 15.26 0 0 0 13.79 17.29 15.28 15.28 0 0 0 16.46-13.15c.52-3.83 1-7 1-7.41 0 0 13.11.56 15.81-12.12 1.3-6.13 3-19 4.32-30.61a24.15 24.15 0 0 0-19.2-26.47l-1.23-.24c-13.38-1.89-22.45 8.43-23.95 21.86Z",
    transform: "translate(-23.82 -29.83)"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-12",
    d: "M532.45 271a30.22 30.22 0 0 1-15.64-8s2.09 9.94 15 11.33Z",
    transform: "translate(-23.82 -29.83)"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M546.82 239.28a1.85 1.85 0 0 1-2.12 1.48 1.77 1.77 0 0 1-1.54-2 1.85 1.85 0 0 1 2.11-1.49 1.77 1.77 0 0 1 1.55 2.01ZM548.54 234.16c-.27.19-1.44-1.1-3.4-1.48s-3.58.3-3.74 0c-.08-.13.23-.51 1-.84a5 5 0 0 1 3-.31 4.86 4.86 0 0 1 2.65 1.48c.51.6.63 1.07.49 1.15ZM528.6 236.13a1.85 1.85 0 0 1-2.12 1.48 1.76 1.76 0 0 1-1.54-2 1.84 1.84 0 0 1 2.11-1.48 1.77 1.77 0 0 1 1.55 2ZM529.27 230.69c-.28.19-1.45-1.1-3.41-1.49s-3.58.31-3.74 0c-.08-.13.23-.51 1-.84a5 5 0 0 1 3-.31 4.92 4.92 0 0 1 2.65 1.47c.51.62.63 1.08.5 1.17ZM533.46 246.6a12.82 12.82 0 0 1 3.29.06c.51.05 1 0 1.15-.28a2.57 2.57 0 0 0 0-1.55c-.22-1.3-.46-2.66-.71-4.09-1-5.82-1.56-10.56-1.33-10.6s1.21 4.65 2.18 10.47c.22 1.43.44 2.79.65 4.1a3 3 0 0 1-.13 2 1.3 1.3 0 0 1-1 .57 3.33 3.33 0 0 1-.87-.06 13 13 0 0 1-3.23-.62ZM527.44 246.8c.32 0-.1 2.17 1.42 4s3.82 2.09 3.77 2.39c0 .14-.58.31-1.54.15a5.42 5.42 0 0 1-3.18-1.88 4.7 4.7 0 0 1-1-3.35c.09-.87.39-1.35.53-1.31Z",
    transform: "translate(-23.82 -29.83)"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M531.3 223.13c-.3.49-2.2-.15-4.55-.33s-4.32.07-4.53-.46c-.09-.26.33-.69 1.18-1.06a8 8 0 0 1 6.92.61c.77.5 1.11 1.01.98 1.24ZM549 228.36c-.44.38-1.69-.35-3.3-.7s-3-.3-3.28-.82c-.09-.26.21-.66.9-1a4.88 4.88 0 0 1 5.29 1.23c.44.61.54 1.11.39 1.29Z",
    transform: "translate(-23.82 -29.83)"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-11",
    d: "M507.24 233.24c-.2-.14-8.22-4.33-9.68 4.42s7.63 8.41 7.68 8.16 2-12.58 2-12.58Z",
    transform: "translate(-23.82 -29.83)"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-12",
    d: "M503.12 242.06s-.17.08-.44.15a1.55 1.55 0 0 1-1.15-.16c-.87-.5-1.4-2.09-1.18-3.68a5.18 5.18 0 0 1 .79-2.11 1.82 1.82 0 0 1 1.34-1 .79.79 0 0 1 .83.57c.08.27 0 .43 0 .45s.21-.11.2-.48a1 1 0 0 0-.25-.61 1.16 1.16 0 0 0-.81-.36 2.17 2.17 0 0 0-1.82 1.09 5.2 5.2 0 0 0-.93 2.35c-.24 1.77.39 3.57 1.59 4.15a1.69 1.69 0 0 0 1.44 0c.34-.15.42-.34.39-.36Z",
    transform: "translate(-23.82 -29.83)"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-8",
    d: "M555 216.66c-1.5 3.23-9.22 4.48-14.88 2.77-5.21-1.57-7.11-4.88-10.42-7.77-2.1-1.83-2.1-1.83-5.53-2.18-2.77-.29-5 2.47-7.09 4.3 1.17 7-1.92 13.84-4.94 20.21a3.51 3.51 0 0 1-1.41 1.81c-1.18.58-2.6-.34-3.31-1.46a11 11 0 0 1-1.23-6.14 36.54 36.54 0 0 1 2.91-14.08 24.74 24.74 0 0 1 9.14-11 23.5 23.5 0 0 1 17.4-2.88 28.88 28.88 0 0 1 15.25 9.15 16.86 16.86 0 0 1 4.11 7.22",
    transform: "translate(-23.82 -29.83)"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M537.24 237.8c.08 0 0-.75.4-2a8.52 8.52 0 0 1 3.1-4.5 8.24 8.24 0 0 1 7.74-1.11 8.1 8.1 0 0 1 3.77 2.85 8.11 8.11 0 0 1 0 9.59 8.1 8.1 0 0 1-3.77 2.85 8.22 8.22 0 0 1-7.74-1.12 8.47 8.47 0 0 1-3.1-4.49c-.35-1.28-.32-2-.4-2a2.15 2.15 0 0 0 0 .55 6.4 6.4 0 0 0 .18 1.55 8.38 8.38 0 0 0 3.06 4.83 8.7 8.7 0 0 0 12.32-1.8 8.7 8.7 0 0 0 0-10.41 8.7 8.7 0 0 0-12.36-1.72 8.36 8.36 0 0 0-3.06 4.82 6.52 6.52 0 0 0-.18 1.56 2 2 0 0 0 .04.55ZM516.49 234.18c.08 0 0-.75.4-2a8.49 8.49 0 0 1 3.1-4.5 8.22 8.22 0 0 1 7.74-1.11 8.08 8.08 0 0 1 3.77 2.84 8.12 8.12 0 0 1 0 9.6 8 8 0 0 1-3.77 2.84 8.22 8.22 0 0 1-7.74-1.11 8.49 8.49 0 0 1-3.1-4.5c-.35-1.27-.32-2-.4-2a2.1 2.1 0 0 0 0 .54 6.52 6.52 0 0 0 .18 1.56 8.38 8.38 0 0 0 3.06 4.83 8.72 8.72 0 0 0 12.37-1.72 8.73 8.73 0 0 0 0-10.42 8.7 8.7 0 0 0-12.36-1.72 8.41 8.41 0 0 0-3.06 4.83 6.52 6.52 0 0 0-.18 1.56 2 2 0 0 0-.01.48Z",
    transform: "translate(-23.82 -29.83)"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-7",
    d: "M533.59 234.48c.09.17 1.2-.35 2.49.05s1.94 1.43 2.11 1.33 0-.37-.25-.81a3.09 3.09 0 0 0-3.69-1.11c-.49.2-.71.46-.66.54ZM504.74 231.94c0 .2 2.79.31 6.23.27s6.22-.25 6.22-.45-2.79-.31-6.23-.26-6.22.24-6.22.44Z",
    transform: "translate(-23.82 -29.83)"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    className: "xml_svg__cls-1",
    d: "M559.13 208.31a2.57 2.57 0 0 1-.14.83 4.08 4.08 0 0 1-1.31 1.88 5.78 5.78 0 0 1-3.15 1.29 15.74 15.74 0 0 1-4.17-.22 73.36 73.36 0 0 1-7.42-1.49c-.94-.25-1.7-.46-2.21-.62l-.6-.19-.2-.08h.21l.61.15 2.22.55c1.88.45 4.5 1 7.42 1.44a15.88 15.88 0 0 0 4.12.23 5.74 5.74 0 0 0 3.08-1.21 4.12 4.12 0 0 0 1.32-1.79c.18-.47.19-.78.22-.77ZM561.07 210.29a8.08 8.08 0 0 1-.75 2.4 10.24 10.24 0 0 1-9.87 5.89 8.09 8.09 0 0 1-2.46-.47 4.33 4.33 0 0 1 .66.13 12.31 12.31 0 0 0 1.81.2 10.4 10.4 0 0 0 9.72-5.82 9.66 9.66 0 0 0 .68-1.69 5 5 0 0 1 .21-.64Z",
    transform: "translate(-23.82 -29.83)"
  }))));
};
/* harmony default export */ var xml = (SvgXml);
;// CONCATENATED MODULE: ./pages/xml.js








var XmlPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Автоматический импорт объявлений для агентств недвижимости",
                description: "Автоматический импорт xml фида загрузка выгрузка объявлений посредство xml фид фида по недвижимости для агентств недвижимости",
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: "Автоматический импорт объявлений для агентств недвижимости",
                    description: "Автоматический импорт xml фида загрузка выгрузка объявлений посредство xml фид фида по недвижимости для агентств недвижимости",
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: [
                                "fixed",
                                (About_module_default()).timeline
                            ].join(" "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Автоматическая выгрузка для агентств недвижимости"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "fixed",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).bigMap,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(xml, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).description,
                                        children: "Мы принимаем автоматические XML-выгрузки в формате Яндекс.Недвижимость."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).description,
                                        children: 'Скопируйте ссылку на автовыгрузку в поле ниже и нажмите на кнопку "подключить фид".'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).description,
                                        children: "Мы разместим ваши объявления и будем автоматически обновлять их."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (About_module_default()).tip,
                                        children: [
                                            "Фиды в формате Яндекс.Недвижимости, валидация происходит в соответствие с ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://yandex.ru/support/realty/requirements/requirements-sale-housing.html",
                                                target: "_blank",
                                                children: "требованиям"
                                            }),
                                            " Яндекс.Недвижимости."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (About_module_default()).action,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SplitterFeed, {
                                    title: "Подключить фид"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                seo: "Импорт xml файла на сайте База - подключить агентство"
            })
        ]
    });
};
/* harmony default export */ var pages_xml = (XmlPage);


/***/ }),

/***/ 7287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"splitter":"SplitterFeed_splitter__4g89F","text":"SplitterFeed_text__7P8A_","title":"SplitterFeed_title__G1Tav","subtitle":"SplitterFeed_subtitle__07B_j","actions":"SplitterFeed_actions__qGN2F","input":"SplitterFeed_input__hWy54","inputZone":"SplitterFeed_inputZone__dxeqD","inputButton":"SplitterFeed_inputButton__TZJmC","no-animation":"SplitterFeed_no-animation__ivV4y","no-border":"SplitterFeed_no-border__bKG44","fullWidth":"SplitterFeed_fullWidth__LJXDP","help":"SplitterFeed_help__TN_22"};

/***/ }),

/***/ 1319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__h9LCE","txtTitle":"Textarea_txtTitle__NdQd9","txtContent":"Textarea_txtContent__t4AHN","full":"Textarea_full__ldXF7","error":"Textarea_error__z_vDn"};

/***/ }),

/***/ 9616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"About_description__O_rw7","mapBlock":"About_mapBlock___ROuy","bigMap":"About_bigMap__Pj69Q","region":"About_region__PEUA5","aboutBlocks":"About_aboutBlocks__Xg6ef","aboutBlock":"About_aboutBlock__vX2ZQ","aboutBlockHeader":"About_aboutBlockHeader__rdH1s","aboutBlockImage":"About_aboutBlockImage__fkHNv","aboutBlockBody":"About_aboutBlockBody__ytu94"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,798,3193,9774,2888,179], function() { return __webpack_exec__(3860); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);